module.exports = __webpack_public_path__ + "static/img/RG-Corporation-2.ed8ea2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/RG-Corporation-2.png
// module id = RVYu
// module chunks = 1